module.exports = __webpack_public_path__ + "static/media/thumbnail.1b636b31.jpg";